export default __webpack_public_path__ + "static/media/unacceptable-photo-too-much-fun.9e0fad05.png";